export interface ClientAccountAddress {
    id?: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    addressLine3: string | null;
    town: string | null;
    county: string | null;
    postcode: string | null;
    foreignAddress?: string | null;
    isForeignAddress?: boolean | false;
}

export function createClientAccountAddress(): ClientAccountAddress {
    return {
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        town: null,
        county: null,
        postcode: null,
        isForeignAddress: false,
        foreignAddress: null,
    };
}
